export const deepCopyObject = (curr: any) => {
  return JSON.parse(JSON.stringify(curr))
}
